import { EnumTipoProposta } from "./tiposProposta";

export const PROPOSTAS_POR_PRODUTO: Record<string, string[]> = {
  CARTAO_BENEFICIO: [
    EnumTipoProposta.CARTAO_SACADO,
    EnumTipoProposta.CARTAO_SEM_SAQUE,
    EnumTipoProposta.SAQUE_COMPLEMENTAR,
    EnumTipoProposta.SAQUE_REFIN,
    EnumTipoProposta.COMPRA_DIVIDA_SAQUE,
  ],

  CARTAO_CREDITO: [
    EnumTipoProposta.CARTAO_SACADO,
    EnumTipoProposta.CARTAO_SEM_SAQUE,
    EnumTipoProposta.SAQUE_COMPLEMENTAR,
    EnumTipoProposta.SAQUE_REFIN,
  ],

  ANTECIPACAO_REMUNERACAO: [
    EnumTipoProposta.NOVO,
  ],

  EMPRESTIMO: [
    EnumTipoProposta.NOVO,
    //EnumTipoProposta.COMPRA_DIVIDA,
  ],
};
